// Module
var code = "<div name=nodeCommandAction ng-mousedown=execute($event)> <span nlg-analysis-tree-property node=::node property=::property.innerNodeProperty></span> </div>";
// Exports
module.exports = code;